const holidayResponseStatuses = {
  OK: 'OK',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
};

export default holidayResponseStatuses;



// WEBPACK FOOTER //
// ./src/constants/holidayResponseStatuses.js